const Pages = {
  home: '/',
  friends: '/friends',
  quests: '/quests',
  leaderbord: '/leaderbord',
  boosters: '/boosters',
  store: '/store',
  testField: '/test-field',
  chests: '/chests',
  chest(id = ':id') {
    return `${this.chests}/${id}`;
  },
  upgrade: '/upgrade',
  dropBank: '/drop-bank',
} as const;

export default Pages;
